import React from 'react';
import { useTheme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import { Paper, Box, Typography, Chip, Divider, Stack } from '@mui/material';
import {
  Apps as AppIcon,
  ModelTraining as ModelIcon,
  Storage as NodeIcon,
  Cloud as DeployIcon,
} from '@mui/icons-material';

const StatusOverview = ({ deploymentConfig, activeTab }) => {
  const theme = useTheme();
  const steps = [
    {
      label: "App",
      icon: <AppIcon />,
      value: deploymentConfig?.name,
      active: activeTab >= 1,
      completed: !!deploymentConfig?.type,
      details: deploymentConfig?.type
    },
    {
      label: "Models",
      icon: <ModelIcon />,
      value: deploymentConfig?.models?.length ? `${deploymentConfig.models.length} Selected` : null,
      active: activeTab >= 2,
      completed: deploymentConfig?.models?.length > 0,
      details: deploymentConfig?.models?.length ? "Ready to deploy AI agents?" : null
    },
    {
      label: "Nodes",
      icon: <NodeIcon />,
      value: deploymentConfig?.nodes?.length ? `${deploymentConfig.nodes.length} Nodes` : null,
      active: activeTab >= 3,
      completed: deploymentConfig?.nodes?.length > 0,
      details: deploymentConfig?.nodes?.length ? "Configuration complete" : null
    }
  ];

  return (
    <Paper 
      elevation={1}
      sx={{ 
        py: 2,
        px: 3,
        background: `linear-gradient(to right, ${alpha(theme.palette.info.main, 0.05)}, ${alpha(theme.palette.info.main, 0.1)})`,
        borderLeft: '4px solid',
        borderColor: theme.palette.info.main,
        height: '60px',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Stack 
        direction="row" 
        spacing={3}
        divider={
          <Divider orientation="vertical" flexItem sx={{ my: 1 }} />
        }
        sx={{ width: '100%' }}
      >
        {steps.map((step) => (
          <Box 
            key={step.label} 
            sx={{ 
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              opacity: step.active ? 1 : 0.7,
              transition: 'all 0.2s ease'
            }}
          >
            <Box sx={{ 
              color: step.completed ? 'primary.main' : 'text.secondary',
              display: 'flex',
              '& > svg': { fontSize: '1.2rem' }
            }}>
              {step.icon}
            </Box>
            
            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Typography 
                  variant="body2"
                  color="text.secondary"
                >
                  {step.label}:
                </Typography>
                <Typography 
                  variant="body2"
                  sx={{ 
                    fontWeight: step.completed ? 500 : 400,
                    color: step.completed ? 'text.primary' : 'text.disabled',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {step.value || 'Not set'}
                </Typography>
              </Box>
              {step.details && (
                <Typography 
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    display: 'block',
                    fontSize: '0.75rem',
                    lineHeight: 1.2
                  }}
                >
                  {step.details}
                </Typography>
              )}
            </Box>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
};

export default StatusOverview;